// extracted by mini-css-extract-plugin
export default {"normalList":"TermsOfServicePage_normalList__qKJe7"};